const request = {
    invalid_input: 'Неверный ввод. {{details}}',
    general: 'Произошла ошибка запроса.',
};
export default request;
